module.exports = __webpack_public_path__ + "assets/devices/PGM-d91ce12f6b2db0d5eb0211cfa2f99785.svg";